import { Fragment } from 'react'
import Contactpage from '../../components/Contactpage/Contactpage'
import Navbar from '../../components/Navbar/Navbar'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation'
import Footer from '../../components/footer/Footer'
import Hero9 from '../../components/hero9/hero9'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo-2.png'

const ContactPage = () => {
  return (
    <Fragment>
      <Navbar
        hclass={'wpo-site-header wpo-header-style'}
        Logo={Logo}
        col1={'col-lg-3 col-md-1 col-2 d-lg-none dl-block'}
        col2={'col-lg-5 col-md-11 col-10'}
        col3={'col-lg-7 col-md-1 col-1'}
        col4={'col-lg-2 col-md-2 col-2'}
      />
      <Hero9 />
      <PageTitle pageTitle={''} pagesub={'Contact Us'} />
      <ScrollTextAnimation />
      <Contactpage />
      <section className="wpo-contact-map-section">
        <h2 className="hidden">Contact map</h2>
        <div className="wpo-contact-map">
          
          <iframe
            title="map"
           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1714.803556674286!2d43.966795713430784!3d36.18689174168689!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x400723000ed3551d%3A0xc63c0f6d68ea2309!2sItaly%201%20City!5e0!3m2!1sen!2siq!4v1762634879959!5m2!1sen!2siq"
            allowFullScreen
          ></iframe>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}
export default ContactPage
